import calendar from "./calendar.store";
import company from "./company.store";
import companyAttachment from "./company-attachment.store";
import companyRequest from "./company-request.store";
import companyProduct from "./company-product.store";
import companyCountry from "./company-country.store";
import companyInspection from "./company-inspection.store";
import companyCalendar from "./company-calendar.store";
import companyDocReject from "./company-doc-reject.store";
import companyDocRejectProduct from "./company-doc-reject-product.store";
import companyDocRejectProductTopic from "./company-doc-reject-product-topic.store";
import userCompany from "./user-company.store";
import samplingRequest from "./sampling-request.store";
import samplingProduct from "./sampling-product.store";
import samplingProductAnalysis from "./sampling-product-analysis.store";
import certificateRequest from "./certificate-request.store";
import samplingProductAnalysisTopic from "./sampling-product-analysis-topic.store";
import samplingProductAnalysisTopicCountryResult from "./sampling-product-analysis-topic-input-country-result.store";
import samplingProductAnalysisTopicInput from "./sampling-product-analysis-topic-input.store";
import certificateProduct from './certificate-product.store'

export default {
    calendar,
    company,
    companyAttachment,
    companyRequest,
    companyProduct,
    companyCountry,
    companyInspection,
    companyCalendar,
    companyDocReject,
    companyDocRejectProduct,
    companyDocRejectProductTopic,
    userCompany,
    samplingRequest,
    samplingProduct,
    samplingProductAnalysis,
    certificateRequest,
    samplingProductAnalysisTopic,
    samplingProductAnalysisTopicCountryResult,
    samplingProductAnalysisTopicInput,
    certificateProduct
};
